import {
  ALERT_ERROR_BACKGROUND_COLOR,
  ALERT_ERROR_BORDER_COLOR,
  ALERT_ERROR_ICON_COLOR,
  ALERT_SUCCESS_BACKGROUND_COLOR,
  ALERT_SUCCESS_BORDER_COLOR,
  ALERT_SUCCESS_ICON_COLOR,
  ALERT_WARNING_BACKGROUND_COLOR,
  ALERT_WARNING_BORDER_COLOR,
  ALERT_WARNING_ICON_COLOR,
  PP_ERROR_COLOR,
  PP_INFO_COLOR,
  PP_SUCCESS_COLOR,
  PP_SYSTEM_COLOR,
  PP_WARNING_MAIN_COLOR,
  REBRAND_T1_PRIMARY_COLOR,
  REBRAND_T1_PRIMARY_INPUT_BORDER,
  WHITE_COLOR,
} from '@/styles';

export const pageLevelBackgroundColor = {
  error: PP_ERROR_COLOR,
  info: PP_INFO_COLOR,
  success: PP_SUCCESS_COLOR,
  warning: PP_WARNING_MAIN_COLOR,
};

export const pageLevelTextColor = {
  error: WHITE_COLOR,
  info: PP_SYSTEM_COLOR,
  success: WHITE_COLOR,
  warning: PP_SYSTEM_COLOR,
};

export const rebrandAlertBackgroundColors = {
  error: ALERT_ERROR_BACKGROUND_COLOR,
  info: WHITE_COLOR,
  success: ALERT_SUCCESS_BACKGROUND_COLOR,
  warning: ALERT_WARNING_BACKGROUND_COLOR,
};

export const rebrandAlertBorderColors = {
  error: ALERT_ERROR_BORDER_COLOR,
  info: REBRAND_T1_PRIMARY_INPUT_BORDER,
  success: ALERT_SUCCESS_BORDER_COLOR,
  warning: ALERT_WARNING_BORDER_COLOR,
};

export const rebrandAlertIconColors = {
  error: ALERT_ERROR_ICON_COLOR,
  info: REBRAND_T1_PRIMARY_COLOR,
  success: ALERT_SUCCESS_ICON_COLOR,
  warning: ALERT_WARNING_ICON_COLOR,
};
